/* eslint-disable */
// 第三投放页面链接加载，目前有抖音和快手。这个文件是具有副作用的，加载的脚本会在 window 生成一些用户埋点的全局变量
// 各第三的提供的埋点 sdk 各不相同
// const
const noop = (v?: any): any => 0;

// 快手生成的代码只支持 event=Form
// 另外在测试快手是否发出请求时，在 search 参数加入 callback=xxx，这样才会发起请求。
// 快手需要 convert_id
export const ks = () => {
  let rs = noop;
  let rj = noop;
  const root: any = window;
  const promise = new Promise((resolve, reject) => {
    rs = resolve;
    rj = reject;
  });
  const ksscript: any = document.createElement('script');
  ksscript.type = 'text/javascript';
  ksscript.async = true;
  ksscript.onload = () => {
    rs(root._ks_trace);
  };
  ksscript.src =
    'https://static.yximgs.com/udata/pkg/ks-ad-trace-sdk/ks-trace.1.0.0.beta.js';
  document.body.appendChild(ksscript);
  return promise;
};

// 抖音需要 convert_id,tracking_id 注意看控制台
export const douyin = (trackingId: string) => {
  let rs = noop;
  let rj = noop;
  const root: any = window;
  const promise = new Promise((resolve, reject) => {
    rs = resolve;
    rj = reject;
  });
  (function(r: any, d, s, l) {
    const meteor = (r.meteor = r.meteor || []);
    meteor.methods = ['track', 'off', 'on'];
    meteor.factory = function(method: any) {
      return function() {
        const args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        meteor.push(args);
        return meteor;
      };
    };
    for (let i = 0; i < meteor.methods.length; i++) {
      const key = meteor.methods[i];
      meteor[key] = meteor.factory(key);
    }
    meteor.load = function() {
      let js: any = '';
      const fjs: any = d.getElementsByTagName(s)[0];
      js = d.createElement(s);
      js.src = 'https://analytics.snssdk.com/meteor.js/v1/' + l + '/sdk';
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = function() {
        // onload resolve
        rs((window as any).meteor);
      };
    };
    meteor.load();
    if (meteor.invoked) {
      return;
    }
    meteor.invoked = true;
    meteor.track('pageview');
  })(window, document, 'script', trackingId);
  return promise;
};

// 广点通
export const gdt = (trackingId: string) => {
  let rs = noop;
  let rj = noop;
  const promise = new Promise((resolve, reject) => {
    rs = resolve;
    rj = reject;
  });
  (function(g: any, d: any, t: string, e: any, v?: any, n?: any, s?: any) {
    if (g.gdt) return;
    v = g.gdt = function() {
      v.tk ? v.tk.apply(v, arguments) : v.queue.push(arguments);
    };
    v.sv = '1.0';
    v.bt = 0;
    v.queue = [];
    n = d.createElement(t);
    n.async = !0;
    n.src = e;
    n.onload = () => {
      rs(g.gdt);
    };
    s = d.getElementsByTagName(t)[0];
    s.parentNode.insertBefore(n, s);
  })(
    window,
    document,
    'script',
    '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js'
  );
  promise.then((gdt: any) => {
    gdt('init', trackingId);
    gdt('track', 'PAGE_VIEW');
  });
  return promise;
  // gdt('init','1108277698');
  // gdt('track','PAGE_VIEW');
};
// 网易云音乐
export const wym = (trackingId: string) => {
  let rs = noop;
  let rj = noop;
  const root: any = window;
  const promise = new Promise((resolve, reject) => {
    rs = resolve;
    rj = reject;
  });
  (function(r, d, s) {
    const queryString = Math.random();
    const adlink: any = d.createElement(s);
    adlink.type = 'text/javascript';
    adlink.async = true;
    adlink.src =
      '//iadmusicmat.music.126.net/cloudmusic-ad/web-track-js-sdk.js?' +
      queryString;
    const sc: any = d.getElementsByTagName(s)[0];
    sc.parentNode.insertBefore(adlink, sc);
    adlink.onload = () => {
      rs((window as any).adSdk);
    };
  })(window, document, 'script');
  return promise;
};

// 封装成指定方法，与业务挂钩,与平台无关。用于成功支付
export interface ITracker {
  completePay: (...args: any[]) => void;
}
function formatTracker(tracker: any, type: ThirdPart): ITracker {
  let resultTracker: ITracker = {
    completePay: noop,
  };
  if (type === ThirdPart.douyin) {
    resultTracker = {
      completePay: convertId => {
        tracker.track('shopping', { convert_id: convertId });
      },
    };
  } else if (type === ThirdPart.kuaishou) {
    resultTracker = {
      completePay: id => {
        tracker.push({
          event: 'form',
          convertId: id,
        });
      },
    };
  } else if (type === ThirdPart.gdt) {
    resultTracker = {
      completePay: () => {
        console.log('do guanding tong');
        tracker('track', 'COMPLETE_ORDER');
      },
    };
  } else if (type === ThirdPart.wym) {
    resultTracker = {
      completePay: (id, type) => {
        console.log('do wangyimusic', 'id:', id, 'type:', type);
        tracker.dispatch(id, type);
      },
    };
  } else {
    console.error('不存在对应平台上报类型');
  }
  return resultTracker;
}
const errorLog = () => {
  console.error('无对应第三方埋点功能');
};
const defaultTracker: ITracker = {
  completePay: errorLog,
};
export enum ThirdPart {
  kuaishou = 'kuaishou',
  douyin = 'douyin',
  gdt = 'guangdiantong',
  wym = 'wangyi_music',
}
export function loadScript(
  type: ThirdPart,
  scriptId?: string
): Promise<ITracker> | null {
  let p;
  if (type === ThirdPart.kuaishou) {
    p = ks();
  } else if (type === ThirdPart.douyin) {
    p = douyin(scriptId || '0');
  } else if (type === ThirdPart.gdt) {
    p = gdt(scriptId || '0');
  } else if (type === ThirdPart.wym) {
    p = wym(scriptId || '0');
  } else {
    return null;
  }
  return p.then((tracker: any) => {
    return formatTracker(tracker, type);
  });
}
